import type { AssetCalculationStrategy, CountryConfig, AssetCategory, AssetConfig, AssetTypeDefinition } from '../types'

export const uaeAssetStrategy: AssetCalculationStrategy = {
  calculateNetWorth(
    assets: Record<string, number>,
    config: CountryConfig
  ): number {
    let total = 0

    for (const category of Object.values(config.assets)) {
      for (const assetDef of category) {
        if (assetDef.enabled) {
          const value = assets[assetDef.fieldMapping] || 0
          total += value
        }
      }
    }

    return total
  },

  calculateLiquidNetWorth(
    assets: Record<string, number>,
    config: CountryConfig
  ): number {
    let total = 0

    // UAE: Exclude real estate from liquid net worth
    const liquidCategories: (keyof AssetConfig)[] = [
      'investment', 'employerEquity', 'cash', 'benefits'
    ]

    for (const [categoryName, category] of Object.entries(config.assets)) {
      if (liquidCategories.includes(categoryName as keyof AssetConfig)) {
        for (const assetDef of category) {
          if (assetDef.enabled) {
            const value = assets[assetDef.fieldMapping] || 0
            total += value
          }
        }
      }
    }

    return total
  },

  getAssetsByCategory(
    assets: Record<string, number>,
    category: AssetCategory,
    config: CountryConfig
  ): { id: string; name: string; value: number }[] {
    const categoryAssets = config.assets[category] || []

    return categoryAssets
      .filter((assetDef: AssetTypeDefinition) => assetDef.enabled)
      .map((assetDef: AssetTypeDefinition) => ({
        id: assetDef.id,
        name: assetDef.name,
        value: assets[assetDef.fieldMapping] || 0,
      }))
      .filter((asset: { id: string; name: string; value: number }) => asset.value > 0)
  },
}
